import { ProductCategory } from "./product-category.model";
import { WashingType } from "./washing-type.model";
import { Garment } from "./garment.model";

export class Product
{
    id?: number;
    enabled?: boolean;
    name?: string;
    internalCode?: string;
    labelType?: string;
    washingType?: WashingType;
    maxWashingNumber?: number;
    weight?: number;
    multiPack?: number;
    deliveryPack?: number;
    repaymentPrice?: string;
    category?: ProductCategory;
    garments?:Garment [];
    constructor()
    {
        this.id = 0;
        this.enabled = true;
        this.name = "";
        this.internalCode = "";
        this.labelType = "";
        this.washingType = new WashingType();
        // this.maxWashingNumber = 0;
        // this.weight = 0;
        this.repaymentPrice = "";
        this.category = new ProductCategory();
    }

    getId?(): number
    {
        return this.id;
    }

    setId?(id: number)
    {
        this.id = id;
    }

    getEnabled?(): boolean
    {
        return this.enabled;
    }
    setEnabled?(enabled: boolean)
    {
        this.enabled = enabled;
    }

    getName?(): string
    {
        return this.name;
    }

    setName?(productName: string)
    {
        this.name = productName;
    }

    getInternalCode?(): string
    {
        return this.internalCode;
    }

    setInternalCode?(idCode: string)
    {
        this.internalCode = idCode;
    }

    getLabelType?(): string
    {
        return this.labelType;
    }

    setLabelType?(labelType: string)
    {
        this.labelType = labelType;
    }

    getWeight?(): number
    {
        return this.weight;
    }

    setWeight?(productWeight: number)
    {
        this.weight = productWeight;
    }

    getWashingType?(): WashingType
    {
        return this.washingType;
    }

    setWashingType?(washingType: WashingType)
    {
        this.washingType = washingType;
    }

    getMaxWashingNumber?(): number
    {
        return this.maxWashingNumber;
    }

    setMaxWashingNumber?(maxWashingNumber: number)
    {
        this.maxWashingNumber = maxWashingNumber;
    }

    getRepaymentPrice?(): string
    {
        return this.repaymentPrice;
    }

    setRepaymentPrice?(repaymentPrice: string)
    {
        this.repaymentPrice = repaymentPrice;
    }

    getCategory?(): ProductCategory
    {
        return this.category;
    }
    setCategory?(category: ProductCategory)
    {
        this.category = category;
    }
}



// WEBPACK FOOTER //
// ./src/app/+core/common/model/product.model.ts